"use client";

/**
 * Общие визуальные константы блока заключений: цвета, иконки, подписи.
 * Меняешь стиль статусов — здесь. Тексты локализованы через i18n (verdict-*).
 */
import { useTranslations } from "next-intl";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import type { VerdictStatus } from "./types";

/** Градиент активной кнопки и баннера (--Violet: 271deg, #B20BFF → #0059FF) */
export const VERDICT_GRADIENT =
  "bg-[linear-gradient(271deg,#B20BFF_0%,#0059FF_109.62%)]";

export const STATUS_COLOR: Record<VerdictStatus, string> = {
  honest: "#16a34a", // зелёный
  dishonest: "#dc2626", // красный
};

export const COMMENT_MAX_LENGTH = 300;

/** Локализованные подписи блока (i18n-ключи verdict-*) */
export function useVerdictLabels() {
  const t = useTranslations();
  return {
    bannerQuestion: t("verdict-banner-question"),
    honest: t("verdict-honest"),
    dishonest: t("verdict-dishonest"),
    historyTitle: t("verdict-history-title"),
    fullHistoryTitle: t("verdict-full-history-title"),
    addCommentTitle: t("verdict-add-comment-title"),
    modalTitle: t("verdict-modal-title"),
    tabView: t("verdict-tab-view"),
    tabCompose: t("verdict-tab-compose"),
    emptyHistory: t("verdict-empty-history"),
    commentPlaceholder: t("verdict-comment-placeholder"),
    save: t("verdict-save"),
    cancel: t("verdict-cancel"),
    setStatusHonest: t("verdict-set-status-honest"),
    setStatusDishonest: t("verdict-set-status-dishonest"),
    addedComment: t("verdict-added-comment"),
    removeTag: t("verdict-remove-tag"),
  };
}

export type VerdictLabels = ReturnType<typeof useVerdictLabels>;

/** Иконка статуса (👍 / 👎) */
export function StatusIcon({ status, className }: { status: VerdictStatus; className?: string }) {
  const Icon = status === "honest" ? ThumbsUp : ThumbsDown;
  return <Icon className={className} style={{ color: STATUS_COLOR[status] }} aria-hidden />;
}

/**
 * Текст записи журнала:
 *  • смена статуса        → «Сменил(а) статус на Честно/Не честно»
 *  • тот же статус подряд → «Добавил(а) комментарий»
 */
export function statusText(
  status: VerdictStatus,
  isStatusChange: boolean,
  labels: VerdictLabels,
): string {
  if (!isStatusChange) return labels.addedComment;
  return status === "honest" ? labels.setStatusHonest : labels.setStatusDishonest;
}
